import { ResourceCalendarCreateAction } from '@/components/resourceCalendarCreateCell/model/ResourceCalendarCreateCell.model.ts';

export type ResourceCalendarCreateCellTranslation = {
  ariaLabel: Record<
    ResourceCalendarCreateAction,
    {
      withEntry: string;
      withoutEntry: string;
    }
  >;
  label: Record<ResourceCalendarCreateAction, string>;
};

export const resourceCalendarCreateCellTranslation: ResourceCalendarCreateCellTranslation = {
  ariaLabel: {
    CHOICE: {
      withEntry: 'Utwórz proces lub rezerwację stałą: {{entry}}, {{range}}',
      withoutEntry: 'Utwórz proces lub rezerwację stałą: {{range}}',
    },
    PROCESS: {
      withEntry: 'Utwórz proces: {{entry}}, {{range}}',
      withoutEntry: 'Utwórz proces: {{range}}',
    },
    RECURRING_RESERVATION: {
      withEntry: 'Utwórz rezerwację stałą: {{entry}}, {{range}}',
      withoutEntry: 'Utwórz rezerwację stałą: {{range}}',
    },
  },
  label: {
    CHOICE: 'Utwórz',
    PROCESS: 'Utwórz proces',
    RECURRING_RESERVATION: 'Utwórz rezerwację stałą',
  },
};
